const colors = {
  pb5: '#EBF9FF',
  pb10: '#DFF8FF',
  pb20: '#C4EDFF',
  pb30: '#9BD8F9',
  pb40: '#68BAE8',
  pb50: '#3396D3',
  pb60: '#0876BF',
  pb70: '#00609C',
  pb80: '#005081',
  pb90: '#00446C',
  pb100: '#003A5C',
  pr5: '#FFEDF1',
  pr10: '#FDE6EA',
  pr20: '#F9D4DB',
  pr30: '#F3B8C1',
  pr40: '#EB919C',
  pr50: '#E0656F',
  pr60: '#D23D43',
  pr70: '#C11F21',
  pr80: '#AD0F0D',
  pr90: '#9A0803',
  pr100: '#870500',
  pg5: '#F5F5F5',
  pg10: '#F0F0F0',
  pg20: '#E3E3E3',
  pg30: '#CDCDCD',
  pg40: '#ADADAD',
  pg50: '#888888',
  pg60: '#636363',
  pg70: '#464646',
  pg80: '#323232',
  pg90: '#262626',
  pg100: '#212121',
  sg5: '#EEFFED',
  sg10: '#E5FBE4',
  sg20: '#CEF0CD',
  sg30: '#A7DDA7',
  sg40: '#77C17A',
  sg50: '#48A052',
  sg60: '#268134',
  sg70: '#116723',
  sg80: '#065619',
  sg90: '#024C15',
  sg100: '#004713',
  sr5: '#FFF2F5',
  sr10: '#FCEAEE',
  sr20: '#F4D5DC',
  sr30: '#E6B2BF',
  sr40: '#D28497',
  sr50: '#BB566E',
  sr60: '#A4314A',
  sr70: '#921831',
  sr80: '#850A21',
  sr90: '#7D0317',
  sr100: '#7A0010',
  so5: '#FFF4E7',
  so10: '#FCEDDB',
  so20: '#F3DBBD',
  so30: '#E3BE8D',
  so40: '#CD9852',
  so50: '#B37217',
  so60: '#995B00',
  so70: '#855000',
  so80: '#774900',
  so90: '#6F4400',
  so100: '#6B4200',
  sb5: '#E8F4FF',
  sb10: '#E1F6FF',
  sb20: '#CAEDFF',
  sb30: '#A1D6FF',
  sb40: '#6AB3FF',
  sb50: '#318AF0',
  sb60: '#0065E0',
  sb70: '#004BAC',
  sb80: '#003681',
  sb90: '#00265D',
  sb100: '#001940',
}

export default colors
